<template>
  <div
    class="LineOptions"
    :class="{
      'LineOptions--isFullWidth': isFullWidth,
      'LineOptions--isError': color === LINE_OPTIONS_COLORS.error,
    }"
  >
    <v-btn
      v-for="(option, index) in options"
      :key="index"
      text
      class="LineOptions_option theme-button theme-button--inherit-color"
      :class="{
        'theme-button--large': size === LINE_OPTIONS_SIZES.large,
        'theme-button--medium': size === LINE_OPTIONS_SIZES.medium,
        'theme-button--small': size === LINE_OPTIONS_SIZES.small,
        'LineOptions_option--isCurrent': option[optionKey] === internalValue,
        'LineOptions_option--isLarge': size === LINE_OPTIONS_SIZES.large,
      }"
      @click="internalValue = option[optionKey]"
    >
      {{ option[optionLabel] }}
    </v-btn>
  </div>
</template>

<script type="text/javascript">
  import { LINE_OPTIONS_SIZES, LINE_OPTIONS_COLORS } from './LineOptions.const'

  export default {
    props: {
      options: {
        type: Array,
        required: true,
      },
      value: {
        type: [String, Number, Boolean, null,],
        default: null,
      },
      optionKey: {
        type: String,
        default: 'key',
      },
      optionLabel: {
        type: String,
        default: 'label',
      },
      size: {
        type: String,
        default: LINE_OPTIONS_SIZES.medium,
        validator: (value) => !!LINE_OPTIONS_SIZES[value],
      },
      isFullWidth: {
        type: Boolean,
        default: false,
      },
      color: {
        type: String,
        default: LINE_OPTIONS_COLORS.default,
      },
    },
    data() {
      return {
        LINE_OPTIONS_SIZES,
        LINE_OPTIONS_COLORS,
      }
    },
    computed: {
      internalValue: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
  }
</script>

<style scoped lang="scss">
.LineOptions {
  $root: &;
  display: flex;
  flex-wrap: wrap;
  border-radius: 8px;

  &--isFullWidth {
    width: 100%;

    #{$root}_option {
      flex-grow: 1;
    }
  }
  &_option {
    flex: 0 1 auto;
    padding: 12px 19px;
    height: 32px !important;
    transition-duration: 0.2s;
    font-size: 13px !important;
    box-shadow: none !important;
    border-radius: 0;
    background-color: $color-ebebeb;
    &:before {
      background-color: $color-ebebeb;
      content: '';
      opacity: 1 !important;
    }

    &:first-child {
      border-top-left-radius: 2px !important;
      border-bottom-left-radius: 2px !important;
    }

    &:last-child {
      border-top-right-radius: 2px !important;
      border-bottom-right-radius: 2px !important;
    }

    #{$root}--isError &:not(&--isCurrent) {
      color: $color-ff524f !important;
    }

    &--isCurrent {
      box-shadow: 0 4px 8px 0 $color_31_54_139_08;
      background: transparent;
      color: $color-ffffff;
      &:before {
        background-color: $color-004f9f !important;
        border-radius: 2px !important;
        #{$root}--isError & {
          background-color: $color-ff524f !important;
        }
      }
    }
    &--isLarge {
      margin: 0;
      height: 48px !important;
    }
  }
}
</style>
